const messages = {
    availPoints: "Puncte disponibile",
    awaitingPoints: "Puncte în așteptare",
  board: {
    title: "Panou de control",
    title2: "Animație de performanță {year}",
    headline1: "Promoțiile și punctele tale dintr-o privire",
    headline2: "Câștigați puncte pentru achizițiile dvs. de anvelope.",
    pointsBalanceToDate: "SOLD PUNCTE LA ZI",
    availPoints: "Puncte disponibile",
    awaitingPoints: "Puncte în așteptare",
    yourRealisation: "REALIZĂRILE DVS",
    yourEngagement: "Angajamentul dvs. anual: <b>{tyres} anvelope</b>",
    yourPoints: "PUNCTELE DVS",
    yourRetailPurchase: "ACHIZIȚIILE DVS",
    yourRetailPurchaseCCS: "VÂNZĂRILE DVS",
    pointsByPurchase: "punctele generate de achizițiile dvs",
    pointsByBoosters: "puncte generate de boosters",
    pointsByBSPurchase: "Puncte generate de achizițiile dvs. Bridgestone",
    pointsByBSPurchaseCCS:
      "Puncte generate de vânzările dvs. de anvelope Bridgestone",
    remaining: "Anvelopele rămase",
    yourGoal: "Progresul obiectivului",
    unit: "cauciucuri",
    buttons: {
      learnMore: "Aflați mai multe despre punctele dvs.",
      learnMoreAboutMechanism: "Aflați mai multe despre mecanică",
    },
    charts: {
      byBrand: "După marcă",
      bySize: "După mărimea jantei",
    },
    exploreResults: "Descoperiți-vă rezultatele",
    tyreLimitInfo:
      "Pentru fiecare perioadă a campaniei Booster este necesar un volum minim sell-out de 50 de anvelope Bridgestone și/sau Firestone.",
  },
  charts: {
    byBrand: "După marcă",
    bySize: "după dimensiunea jantei",
  },

  dashboard: {
    dashboardTitle: "Beneficiile tale",
    dashboardBox: {
      title: "Echilibrul de puncte",
      description: "Totalul dvs. actual de puncte de marketing",
      availPoints: "Puncte disponibile",
      awaitingPoints: "Puncte în așteptare",
      lastUpdate: "Ultima actualizare",
      button: "Află mai multe",
      points: "points",
    },
  },
  soldTyres: "PNEURI VANZATE",
  receivedPoints: "PUNCTE CÂBÂGATE",
  boosterCCS: {
    personalInfo: "Informații personale",
    csNumberTitle: "Vă rugăm să specificați numărul (numerele) de cont participant",
    tyresTitle: "Vă rugăm să specificați numărul de anvelope vândute",
    minTyresInfo:
      "Este necesar un minim de {tyres} anvelope Bridgestone/Firestone. Compensația se aplică doar pentru anvelopele Bridgestone.",
    tyresAmount: "Nr anvelope",
    filesTitle: "Vă rugăm să încărcați dovada vânzărilor",
    filesDescription:
      "Vă rugăm să rețineți: vor fi luate în considerare numai vânzările care specifică dimensiunea jantei anvelopei.",
    addAnotherFile: "Adăugați un alt document",
    file: "Încărcați documentul",
    formatInfo:
      "Formate de fișiere acceptate: xlsx, jpeg și pdf. Dimensiunea maximă a fișierului: 8 MB",
    confrimationMessage:
      "<b>Vă mulțumim pentru participare!</b> <br/>Solicitarea dvs. a fost primită și transmisă echipelor Bridgestone pentru validare.<br/>Veți primi o notificare prin e-mail cu rezultatele participării dumneavoastră la Booster CCS.<br/>Ne vedem în curând pe Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Distribuie puncte",
    forShare: "Puncte pe care le vei împărți",
    title: "Titlu",
  },
  notFoundFile: "Niciunul selectat",
  chooseFile: "Alegeți fișierul",
};
export default {
  messages,
};
